import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { WalletService } from 'src/services/wallet.service';

@Component({
  selector: 'app-dashboard-wallet',
  templateUrl: './dashboard-wallet.component.html',
  styleUrls: ['./dashboard-wallet.component.scss']
})
export class DashboardWalletComponent implements OnInit {
  boletos: any[] = [];
  boletosFiltrados: any[] = [];
  filtroActual: string = 'TODOS';
  seccion: string = 'boletos';
  descargar = environment.URL_API_MAGNO + '/api/DescargaBoletoPDF/';
  descargaIntentos: { [folio: string]: { conteo: number, fecha: string } } = {};
  URL_MICROSITIO = environment.URL_MICROSITIO;

  constructor(private walletService: WalletService, private router: Router) { }

  ngOnInit(): void {
    this.cargarBoletos();
  }

  cargarBoletos() {
    this.walletService.getBoletos().subscribe(
      (res: any) => {
        this.boletos = res;
        this.boletosFiltrados = res;
      },
      err => { if (err.status === 401) this.logout(); }
    );
  }

  setFiltro(estado: string) {
    this.filtroActual = estado;
    this.boletosFiltrados = estado === 'TODOS' ? this.boletos : this.boletos.filter(b => b.Estado.trim() === estado);
  }

  descargarBoleto(boleto: any) {
    const ahora = new Date();
    const fechaHoy = ahora.toDateString(); // Obtiene algo como 'Thu Apr 23 2026'

    // Si no existe el registro o es un día distinto, reiniciamos el conteo
    if (!this.descargaIntentos[boleto.Folio] ||
      this.descargaIntentos[boleto.Folio].fecha !== fechaHoy) {

      this.descargaIntentos[boleto.Folio] = { conteo: 0, fecha: fechaHoy };
    }

    // Validamos el límite de 3
    if (this.descargaIntentos[boleto.Folio].conteo >= 3) {
      alert("Has alcanzado el límite de 3 descargas por día para este boleto.");
      return;
    }

    // Incrementamos y procedemos
    this.descargaIntentos[boleto.Folio].conteo++;
    window.location.href = `${this.descargar}${boleto.Folio}`;
  }

  logout() {
    localStorage.removeItem('auth_token');
    this.router.navigate(['/login-wallet']);
  }
}